import React, {useEffect, useState} from 'react'
import {BASE_URL} from '../utils/commonUrl';
import Layout from '../components/Layout'
import axios from 'axios';
import {useDispatch, useSelector} from 'react-redux'
import AssestmentTitleForm from "./forms/AssestmentTitleForm";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {fetchAssestmentTitle} from "../redux/features/assestmentTitle.feature";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {InputText} from "primereact/inputtext";

const AssestmentTitle = () => {
    const dispatch = useDispatch();
    const {assestmenttitles,message} = useSelector((state => state["assestmenttitle"]))
    const [modal, setModal] = useState(false)
    const [start, setFirst] = useState(0);
    const [activeAssestmentNames, setactiveAssestmentNames] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [assestmentTitleItem, setAssestmentTitleItem] = useState({
        assestmentTitleID: 0,
        assestmentID: 0,
        assestmentTitleName: "",
        defination: "",
        definationBangla: "",
        indicatorName: "",
        active: true,
    })

    useEffect(() => {
        dispatch(fetchAssestmentTitle())
        AssestmentTitleActiveNames()
        initFilters1();
    }, [])

    const AssestmentTitleActiveNames = async () => {
        try {
            const url = BASE_URL + '/api/assestment/GetActiveList'
            const response = await axios.get(url)
            if (response.status === 200) {
                const optionList = [{value: '-1', label: 'Please Select Assestment'}];
                response.data.map(val => optionList.push({value: val.assestmentID, label: val.assestmentName}))

                setactiveAssestmentNames(optionList)
            }

        } catch (e) {
            console.log(e)
        }

    }
    const onSubmit = async data => {
        try {
            setIsLoading(true)
            const url = BASE_URL + "/api/assestmentTitle";
            const response = await axios.post(url, data);
            setIsLoading(false)
            if (response.status === 200) {
                dispatch(fetchAssestmentTitle())
                setAssestmentTitleItem({
                     assestmentTitleID: 0,
					 assestmentID: 0,
					 assestmentTitleName: "",
					 defination: "",
					 definationBangla: "",
					 indicatorName: "",
					 active: true,
                })
                setModal(!modal)
            }
        } catch (e) {
            console.log(e)
            setIsLoading(false)
        }


    }

    const onHide = () => {
        setModal(!modal)
        setAssestmentTitleItem({
            assestmentTitleID: 0,
					 assestmentID: 0,
					 assestmentTitleName: "",
					 defination: "",
					 definationBangla: "",
					 indicatorName: "",
					 active: true,
        })
    }
    const editGridData = data => {
        setAssestmentTitleItem({
            assestmentTitleID: data.assestmentTitleID,
            assestmentID: data.assestmentID,
            assestmentTitleName: data.assestmentTitleName,
            defination: data.defination,
            definationBangla: data.definationBangla,
            indicatorName: data.indicatorName,
            active: data.active,
        });
        setModal(!modal);
    }

    const deleteGridData = data => {
        //setDeleteassestmentTitleItem({quarterName:data.quarterName,quarterId:data.quarterID})
        //setDeleteProductDialog(true)
    }

    //filter begin

    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }



    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'assestmentTitleName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'defination': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'definationBangla': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'indicatorName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'active': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }


    //filter end


    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                        onClick={() => editGridData(rowData)}/>
                &nbsp;   <Button icon="pi pi-trash" className="p-button-rounded p-button-warning"
                                 onClick={() => deleteGridData(rowData)}/>
            </>
        );
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={clearFilter1}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Keyword Search"/>
                </span>
                </div>
                <button type='button' onClick={() => setModal(!modal)} className='btn btn-primary'>Add Assestment Title
                </button>
            </div>
        </div>
    );
    const footer ='';// `In total there are ${state.assestmenttitle ? state.assestmenttitle.length : 0} assestmenttitle.`;

    const _isActiveColumn = (rowData) => {
        return <div>{rowData.active ? <>Active</> : <>Inactive</>}</div>
    }

    const Table = (
        <DataTable value={assestmenttitles}
                   showGridlines
                   dataKey="assestmentID" filters={filters1} filterDisplay="menu"
                   globalFilterFields={['assestmentTitleName', 'defination','definationBangla','indicatorName','active']}

                   header={header} footer={footer} paginator rows={7} first={start}
                   paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
            <Column field="assestmentTitleID" header="assestmentTitleID" hidden={true}/>
            <Column field="assestmentID" header="assessmentID"/>
            <Column field='assestmentTitleName' header="Title Name"/>
            <Column field='defination' header="definition"/>
            <Column field='definationBangla' header="definition Bangla" hidden={true}/>
            <Column field='indicatorName' header="indicator Name"/>
            <Column field='active' header="Active" body={_isActiveColumn}/>
            <Column body={actionBodyTemplate} header="Action" exportable={false} style={{minWidth: '4rem'}}/>
        </DataTable>
    )

    return (
        <Layout>
            <AssestmentTitleForm
                isLoading={isLoading}
                activeAssestmentNames={activeAssestmentNames}
                assestmentTitleID={assestmentTitleItem.assestmentTitleID}
                assestmentID={assestmentTitleItem.assestmentID}
                assestmentTitleName={assestmentTitleItem.assestmentTitleName}
                defination={assestmentTitleItem.defination}
                definationBangla={assestmentTitleItem.definationBangla}
                indicatorName={assestmentTitleItem.indicatorName}
                active={assestmentTitleItem.active}
                modal={modal}
                onSubmit={onSubmit}
                onHide={onHide}/>
            {Table}
        </Layout>
    )
}

export default AssestmentTitle